<button class="btn btn-default" type="button" (click)="backPage()" attr.aria-label="{{ 'SHARED.COMPONENT.BACK_TO_LIST_BTN' |translate }}">{{ 'SHARED.COMPONENT.BACK_TO_LIST_BTN' |translate }}</button>
